import { HexColor } from '@nx-smartmonkey/shared/domain';
import { RoutalDefaultColors, RoutalPalette } from '@nx-smartmonkey/ui';
import React, { useEffect, useState } from 'react';

import { BlockPicker, ColorResult } from 'react-color';

interface RouteAvatarNameProps {
  name: string;
  color?: string;
  additionalStyles?: React.CSSProperties;
  withColorPicker?: boolean;
  onUpdate?: (color: HexColor) => void;
}

export const RouteAvatarName = ({
  name,
  color,
  additionalStyles = {},
  withColorPicker = false,
  onUpdate = () => {},
}: RouteAvatarNameProps) => {
  const [currentColor, setCurrentColor] = useState<string | undefined>(RoutalPalette.routeBaseColor);
  const [showColorPicker, setShowColorPicker] = useState<boolean>(false);

  useEffect(() => {
    if (color) {
      setCurrentColor(color);
    }
  }, [color]);

  const handleColorChange = ({ hex }: ColorResult) => {
    onUpdate(HexColor.create(hex));
    setShowColorPicker(false);
  };

  const nameIcon = () => {
    return (
      <div
        onClick={() => withColorPicker && setShowColorPicker(!showColorPicker)}
        style={{
          width: 22,
          height: 22,
          borderRadius: `50%`,
          cursor: withColorPicker ? `pointer` : `default`,
          border: `2px solid ${currentColor ?? RoutalPalette.routeBaseColor}`,
          display: `flex`,
          alignItems: `center`,
          justifyContent: `center`,
          ...additionalStyles,
        }}
      >
        <span
          style={{
            color: currentColor ?? RoutalPalette.routeBaseColor,
            fontSize: `11px`,
            fontWeight: 500,
            userSelect: `none`,
          }}
        >
          {name}
        </span>
      </div>
    );
  };

  return (
    <>
      {showColorPicker && withColorPicker ? (
        <>
          {nameIcon()}
          <div
            style={{
              position: `relative`,
              right: `97px`,
              top: `160px`,
              zIndex: 9999,
              boxShadow: `rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px`,
              borderRadius: `6px`,
              width: `0px`,
            }}
          >
            <BlockPicker color={currentColor} colors={RoutalDefaultColors || []} onChangeComplete={handleColorChange} />
          </div>
        </>
      ) : (
        nameIcon()
      )}
    </>
  );
};
